export { default } from './StudentPage';
